import React from 'react'

/** Shown throughout the authenticated patient experience (intake, provider
 * profile, matches, booking) — the pre-signup marketing pages already carry
 * a shorter version, but this is the one place a patient in active use of
 * the product sees the full statement. */
export function EmergencyDisclaimer() {
  return (
    <div className="emergency-disclaimer" role="note">
      ATUUNE is not an emergency service. If you are experiencing a mental health emergency, contact
      your local emergency services or an appropriate crisis resource immediately.
    </div>
  )
}
